

























































import { Vue, Component } from 'vue-property-decorator';
import { Swipe, SwipeItem, Lazyload, List } from 'vant';
import NewsItem from '../components/NewsItem.vue';

import { getNewsList } from '../api';

Vue.use(Swipe).use(SwipeItem).use(Lazyload).use(List);

@Component({
  components: {
    NewsItem,
  },
})
export default class TouTiao extends Vue {
  loading = false;
  finished = false;
  page = 1;
  newsList: any[] = [];

  async created() {
    this.getNewsListFn();
  }
  async getNewsListFn() {
    this.loading = true;
    const ret = await getNewsList({
      page: this.page,
      category: '区县头条',
      classId: 4495,
    });
    this.loading = false;
    if (ret.data.data && ret.data.data.length && ret.data.data[0].list.length) {
      this.newsList = [...this.newsList, ...ret.data.data[0].list];
      this.page++;
    } else {
      this.finished = true;
    }
  }
  onJumpToDetail(data: any) {
    console.log('on nav to detail');
  }
}
